export default {
  article_breadcrumb_home: 'Accueil',
  article_breadcrumb_current: 'Guide du tableur USFans',
  article_category: 'Guides',
  article_reading_time: '8 min de lecture',
  article_updated: 'Mis à jour',
  article_title: 'Guide du tableur USFans : qu’est-ce que c’est et comment l’utiliser',
  article_lead:
    'Un tableur USFans est une façon simple et structurée d’organiser et d’explorer les informations sur les produits, les vendeurs et les ressources. Ce guide explique ce que c’est, pourquoi on l’utilise et comment en tirer le meilleur parti, étape par étape.',

  article_h2_1: 'Qu’est-ce qu’un tableur USFans ?',
  article_p_1:
    'Un tableur USFans est une façon structurée d’organiser et d’explorer les informations sur les produits, les vendeurs et les ressources en un seul endroit. Au lieu de sauter entre des pages dispersées, vous pouvez utiliser des ressources organisées pour découvrir des informations, comparer des options et poursuivre votre recherche plus efficacement.',
  article_p_2:
    'Considérez-le comme une carte de recherche : il regroupe les éléments liés pour que vous voyiez rapidement ce qui est disponible, comparez les détails et décidiez où chercher ensuite. Le tableur lui-même est une façon d’organiser l’information, tandis que les produits et prix actuels se trouvent sur le site principal.',

  article_h2_2: 'Pourquoi utiliser un tableur USFans ?',
  article_p_3:
    'Les gens utilisent des tableurs pour gagner du temps et rester organisés. Lorsque vous explorez de nombreux produits ou vendeurs à la fois, une mise en page structurée vous aide à comparer les options sans perdre de vue ce que vous avez déjà vérifié.',
  article_li_1: 'Organisez de nombreux produits et catégories dans une seule vue',
  article_li_2: 'Comparez produits, vendeurs et ressources côte à côte',
  article_li_3: 'Gardez vos notes de recherche au même endroit',
  article_li_4: 'Passez plus vite de la recherche au site principal',

  article_h2_3: 'Comment utiliser un tableur USFans (pas à pas)',
  article_step_1_title: 'Choisissez une catégorie',
  article_step_1_desc: 'Commencez par une catégorie comme Chaussures, T-shirts ou Sacs pour affiner votre recherche.',
  article_step_2_title: 'Comparez les options',
  article_step_2_desc: 'Regardez les différents éléments et notez les détails qui comptent pour vous.',
  article_step_3_title: 'Vérifiez les informations',
  article_step_3_desc: 'Vérifiez toujours les liens, vendeurs et détails produits de façon indépendante.',
  article_step_4_title: 'Continuez vers le site principal',
  article_step_4_desc: 'Quand vous êtes prêt, suivez les liens vers le site principal pour aller plus loin.',

  article_h2_4: 'Une comparaison rapide',
  article_compare_col_feature: 'Fonctionnalité',
  article_compare_col_a: 'Recherche en tableur',
  article_compare_col_b: 'Recherche de vendeur',
  article_cr1_label: 'Profondeur d’information',
  article_cr1_a: 'Élevée',
  article_cr1_b: 'Moyenne',
  article_cr2_label: 'Facilité d’utilisation',
  article_cr2_a: 'Facile',
  article_cr2_b: 'Modérée',
  article_cr3_label: 'Idéal pour',
  article_cr3_a: 'Comparer les produits',
  article_cr3_b: 'Vérifier les vendeurs',

  article_h2_5: 'Conseils de sécurité',
  article_p_4:
    'Avant d’utiliser un tableur, un lien produit ou une information vendeur, prenez le temps de vérifier la source. Quelques habitudes simples vous aideront à éviter les erreurs courantes.',
  article_safe_1: 'Vérifiez les liens avant de cliquer ou d’acheter',
  article_safe_2: 'Ne partagez jamais vos mots de passe ni vos données sensibles',
  article_safe_3: 'Méfiez-vous des pages non officielles qui copient une vraie marque',
  article_safe_4: 'Vérifiez les prix, la livraison et le stock sur le site principal',

  article_h2_6: 'Questions fréquentes',
  article_faq_q1: 'Un tableur USFans est-il gratuit ?',
  article_faq_a1:
    'Utiliser un tableur organisé comme aide à la recherche est gratuit. Les prix, la livraison et la disponibilité réels sont indiqués sur le site principal.',
  article_faq_q2: 'Où trouver les derniers produits ?',
  article_faq_a2:
    'Les produits et prix les plus récents se trouvent sur le site principal. Utilisez les catégories d’ici pour accéder directement à la section dont vous avez besoin.',
  article_faq_q3: 'Ai-je besoin d’un compte ?',
  article_faq_a3:
    'Pour parcourir les ressources d’ici, aucun compte n’est nécessaire. Le site principal peut avoir ses propres exigences.',

  article_cta_title: 'Continuez votre recherche',
  article_cta_body:
    'Explorez des catégories et ressources organisées, puis continuez vers le site principal quand vous êtes prêt.',
  article_cta_primary: 'Explorez le tableur USFans',
  article_cta_secondary: 'Retour à l’accueil',
  article_not_found: 'Article introuvable',
  article_not_found_desc:
    'L’article que vous cherchez est introuvable. Parcourez nos guides depuis la page d’accueil.',
  article_related: 'Guides associés',

  article_disclaimer:
    'Avertissement : USFansLink.boats est une ressource d’information indépendante et n’est pas le site officiel USFans. Vérifiez toujours de façon indépendante les vendeurs, liens, produits, prix, informations de livraison et détails de transaction avant toute décision.',
};